import styled from 'styled-components';

export const MobHeader = styled.div`
	display: none;
	flex-direction: column;
	gap: 16px;
	padding: 16px 0;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light30};

	@media (max-width: 768px) {
		display: flex;
	}
`;

export const Month = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
`;

export const MonthText = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	min-width: 150px;
	text-align: center;
`;

export const ArrowWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.transparent.light30};
	}

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		width: 18px;
		height: 18px;
	}
`;

export const Filter = styled.div`
	display: flex;
	gap: 8px;
	justify-content: center;
`;

export const FilterWrapper = styled.div<{ $active?: boolean }>`
	padding: 6px 12px;
	border-radius: 16px;
	cursor: pointer;
	transition: all 0.2s;
	background-color: ${props => props.$active ? props.theme.colors.control.primary : props.theme.colors.transparent.light10};
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	color: ${props => props.$active ? props.theme.colors.text.alwaysDark : props.theme.colors.text.body};
	font-size: 14px;

	&:hover {
		background-color: ${props => props.$active ? props.theme.colors.control.hover : props.theme.colors.transparent.light30};
	}
`; 